import * as React from 'react';
import PropTypes from 'prop-types';

// Small pill showing an item's type (requirement / container / hazard / …), per the
// command-palette mockup. Renders nothing when the label is unknown, so a result with
// an unmapped type_id just shows no badge rather than a raw id.
export default function TypeBadge({ label }) {
  if (!label) return null;
  return (
    <span
      className="type-badge"
      data-testid="result-type-badge"
      style={{
        fontSize: 10.5,
        fontWeight: 600,
        letterSpacing: 0.2,
        textTransform: 'lowercase',
        padding: '1px 6px',
        borderRadius: 5,
        whiteSpace: 'nowrap',
        background: 'var(--chip-bg, rgba(120,130,150,0.14))',
        color: 'var(--muted, #6b7280)',
        flexShrink: 0,
      }}
    >
      {label}
    </span>
  );
}

TypeBadge.propTypes = {
  label: PropTypes.string,
};
